import { useTranslation } from 'next-i18next';
import { useBuildFormContext } from '../form/schema';
import { EditableQuizCardWithProvider } from './EditableQuizCard/EditableQuizCardWithProvider';
import { QuizListSortableContainer } from './QuizListSortableContainer';
import { useQuizList } from './useQuizList';
export const QuizList = () => {
  const {
    control
  } = useBuildFormContext();
  const {
    quizList,
    handleDragEnd
  } = useQuizList();
  const {
    t
  } = useTranslation(['build']);
  if (!quizList.length) return <div className="mb-md flex w-full flex-row items-center gap-md">
        <div className="h-[1px] grow bg-opacity-black-3" />
        <span className="text-body-md-semibold text-assistive">
          {t('build.quizList.emptyDescription')}
        </span>
        <div className="h-[1px] grow bg-opacity-black-3" />
      </div>;
  return <QuizListSortableContainer items={quizList.map(quiz => quiz.id)} onDragEnd={handleDragEnd} data-sentry-element="QuizListSortableContainer" data-sentry-component="QuizList" data-sentry-source-file="QuizList.tsx">
      {quizList.map((quiz, index) => {
      // EditableQuizCardWithProvider is memoized to prevent unnecessary re-renders
      // when editing individual cards. Only the edited card will re-render, not the entire list.
      // Uncomment Profiler below to verify performance optimization.
      return <EditableQuizCardWithProvider key={quiz.id} id={quiz.id} index={index} control={control} />;
    })}
    </QuizListSortableContainer>;
};